export const categories = [
  {
    slug: "valuation",
    name: "Valuation",
    description: "Metrics to understand if a stock is cheap or expensive",
    color: "#B68D40"
  },
  {
    slug: "profitability",
    name: "Profitability",
    description: "How efficiently a company turns money into profit",
    color: "#1D9E75"
  },
  {
    slug: "risk",
    name: "Risk",
    description: "Measures of financial stability and debt",
    color: "#A32D2D"
  },
  {
    slug: "returns",
    name: "Returns",
    description: "How to measure investment growth over time",
    color: "#534AB7"
  },
  {
    slug: "market-concepts",
    name: "Market Concepts",
    description: "Indices, exchanges, and how markets work",
    color: "#B68D40"
  },
  {
    slug: "tax",
    name: "Tax",
    description: "Taxation on investments and income",
    color: "#BA7517"
  },
  {
    slug: "products",
    name: "Products",
    description: "Mutual funds, SIPs, ETFs, and investment vehicles",
    color: "#0F6E56"
  },
  {
    slug: "economics",
    name: "Economics",
    description: "Inflation, GDP, repo rate, and macro concepts",
    color: "#993C1D"
  }
];
